import b from 'b_';
import React from 'react';

import './lesson-content__row.scss';

interface OwnProps {
    children: React.ReactNode | Array<React.ReactNode>;
    fullScreen?: boolean;
}

const LessonContentRow = ({ children, fullScreen }: OwnProps) => {
    return <div className={b('lesson-content', 'row', { 'full-screen': fullScreen })}>{children}</div>;
};

export default LessonContentRow;
